import { Paper, Radio, RadioGroup } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import AdFormatHeader from './AdFormatHeader';
import AdFormatItem from './AdFormatItem';
import { AD_FORMATS } from './AdFormats';

const mimeTypeField = 'Dooh.mimeTypes';

const AdFormat = () => {
  const { control } = useFormContext();

  return (
    <Paper className='flex justify-start items-start rounded-lg flex-col break-after-page'>
      <AdFormatHeader />
      <Controller
        control={control}
        name={mimeTypeField}
        render={({ field }) => (
          <RadioGroup
            {...field}
            row
            sx={{ display: 'flex', justifyContent: 'space-between', gap: '8px', padding: '40px', width: '100%' }}
          >
            {AD_FORMATS.map(adFormat => (
              <Radio
                sx={{ height: '100%', padding: 0, flex: 1 }}
                value={adFormat.id}
                key={adFormat.id}
                checkedIcon={<AdFormatItem {...adFormat} checked />}
                icon={<AdFormatItem {...adFormat} />}
                disableRipple
              />
            ))}
          </RadioGroup>
        )}
      />
    </Paper>
  );
};

export default AdFormat;
